export const DEFAULT_CHANNELS: {id: string; label: String; utmSource: string; isMain: boolean}[] = [
  {
    id: "instagram",
    label: "Instagram",
    utmSource: "instagram",
    isMain: true,
  },
  {
    id: "facebook",
    label: "Facebook",
    utmSource: "facebook",
    isMain: true,
  },
  {
    id: "google",
    label: "Google",
    utmSource: "google",
    isMain: true,
  },
  {
    id: "whatsapp",
    label: "WhatsApp",
    utmSource: "whatsapp",
    isMain: true,
  },
  {
    id: "chatgpt",
    label: "ChatGPT",
    utmSource: "chatgpt",
    isMain: false,
  },
  {
    id: "perplexity",
    label: "Perplexity",
    utmSource: "perplexity",
    isMain: false,
  },
  {
    id: "gemini",
    label: "Gemini",
    utmSource: "gemini",
    isMain: false,
  },
  {
    id: "referral",
    label: "Indicação",
    utmSource: "referral",
    isMain: true,
  },
  {
    id: "tiktok",
    label: "TikTok",
    utmSource: "tiktok",
    isMain: true,
  },
  {
    id: "other",
    label: "Outro",
    utmSource: "other",
    isMain: false,
  },
]
